import Vue from "vue";

const URL = "/db/sistem";
const API_URL = URL + "/api/";

const state = {
  sistem: {}
};

const mutations = {
  SET_SISTEM(state, payload) {
    state.sistem = payload;
  }
};

const actions = {
  GET_SISTEM_PUBLIC({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/api_public").then(res => {
      commit("SET_SISTEM", res.data.sistem);
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_SISTEM({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(API_URL).then(res => {
      commit("SET_SISTEM", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  UPDATE_SISTEM({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL, payload)
      .then(res => {
        commit("SET_SISTEM", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
